// removed by extract-text-webpack-plugin
module.exports = {"main-page":"MainPage__main-page___9CUU_"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MainPage/MainPage.scss
 ** module id = 1075
 ** module chunks = 0
 **/